/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const logger = {
	/**
	 * Logs information
	 *
	 * @param message The message to log
	 */
	info: (message: any): void => {
		console.log(message);
	},

	/**
	 * Logs a warning
	 *
	 * @param message The message to log
	 */
	warn: (message: any): void => {
		console.warn(message);
	},

	/**
	 * Logs a debug message
	 *
	 * @param message The message to log
	 */
	debug: (message: any): void => {
		console.debug(message);
	},

	/**
	 * Logs an error
	 *
	 * @param err The error message
	 */
	error: (error: any): void => {
		console.error(error);
	},

	/**
	 * Logs an error and flushes it to the log immediately
	 *
	 * @param err The error message
	 */
	errorAsync: async (error: any): Promise<void> => {
		console.error(error);
	},
};

export default logger;
